import React from 'react';
import Carousel from 'react-material-ui-carousel'
import { Paper, Button, Card, CardMedia, Box, Grid } from '@mui/material'
import Image from 'mui-image';

let items = [
  {
    path: "view_1",
    alt: "Image"
  },
  {
    path: "pixel-ant_2",
    alt: "Image"
  },
  {
    path: "pixel-ant_1",
    alt: "Image"
  },
  {
    path: "badge_5",
    alt: "Image"
  },
  {
    path: "badge_6",
    alt: "Image"
  },
  {
    path: "image_8",
    alt: "Image"
  },  
  {
    path: "image_10",
    alt: "Image"
  },

]

const Images = (props: any) => {
  return (
    <Carousel
      cycleNavigation={true}
      animation="fade"
      duration={700}
      swipe={true}
      autoPlay={true}
      stopAutoPlayOnHover={true}
      fullHeightHover={true}
      navButtonsAlwaysVisible={true}
      sx={{
        width: "100%",
      }}
    >
      {
        items.map( (item, i) => <Item key={i} item={item} /> )
      }
    </Carousel>
  )
}

function Item(props: any)
{
  return (
    <Card sx={{ width: "100%", height: "400px", backgroundColor: "#0a0a0a", overflow: "hidden"}}>
      <CardMedia
        component="img"
        image={`./assets/${props.item.path}.jpg`} 
        alt={props.item.alt}
        sx={{ objectFit: "contain", height: "100%" }}
      />
    </Card>
  )
}

export default Images